import { render } from "./OverviewTab.vue?vue&type=template&id=5e2790a4&ts=true"
import script from "./OverviewTab.vue?vue&type=script&lang=ts"
export * from "./OverviewTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__